// ----------------
// Global variables
// ----------------
const categories = document.querySelectorAll('.js-category'),
    heroContent = document.querySelector('.js-hero'),
    heroContentSuccess = document.querySelector('.js-hero-success'),
    heroContentSuccessCategory = document.querySelector('.js-hero-success-category'),
    form = document.querySelector('.js-products-catalog-form'),
    resultsWrapper = document.querySelector('.js-result-wrapper'),
    results = document.querySelector('.js-results'),
    resultItem = document.querySelector('.js-result-template'),
    otherResultsWrapper = document.querySelector('.js-other-results-wrapper'),
    otherResults = document.querySelector('.js-other-results'),
    modalSubscribe = '#modal-subscribe',
    modalCreateAccount = '#modal-create-account',
    modalThemePreview = document.querySelector('.js-modal-theme-preview'),
    modalThemeBtn = document.querySelector('.js-modal-theme-btn'),
    modalShowShowPreview = '#modal-show-preview',
    modalThumbPreview = document.querySelector('.js-modal-thumb-preview'),
    reloadCategoriesBtn = document.querySelector('.js-reload-categories');

// -------------------------------
// Helpers
// -------------------------------
const textSanitize = (text) => {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

const lineBreakSanitize = (text) => {
  return text.normalize("NFD").replace(/<br\s*\/?>/gi,' ');
}

reloadCategoriesBtn.addEventListener('click', () => {
    window.location.href = window.location.href
})

// -------------------------
// Group results by category
// -------------------------
categories.forEach(category => category.addEventListener('click', () => {
    const categorySelected = category.getAttribute('data-category');
    const categoryNameSelected = category.getAttribute('data-category-name');
    
    for (let index = 0; index < categoryContents.length; index++) {
        const catalogs = categoryContents[index]["catalogs"];
        const taxonomy = categoryContents[index]["category"];
        let moreResults = false;
        
        if (categorySelected == 'all') {
            otherResultsWrapper.classList.add('hide');
        } else if (categorySelected != categoryContents[index]["nice_name"]) {
            moreResults = true;
        }
        
        handleResults(catalogs, taxonomy, moreResults);
    }

    heroContentSuccessCategory.innerHTML = lineBreakSanitize(categoryNameSelected.toLowerCase());
    handleButtonAction();
}));

// -------------------------------
// Show results as a list of cards
// -------------------------------
function handleResults(catalogs, taxonomy, moreResults) {
    if (catalogs) {
        catalogs.forEach(catalog => {
            const clone = resultItem.cloneNode(true).content,
                itemThumbContainer = clone.querySelector('.js-result-item-preview-thumb'),
                itemPreviewContainer = clone.querySelector('.js-result-item-preview-btn'),
                itemCategoryContainer = clone.querySelector('.js-result-item-category'),
                itemNameContainer = clone.querySelector('.js-result-item-name'),
                itemDownloadBtnContainer = clone.querySelector('.js-result-item-link-download'),
                itemCopyBtnContainer = clone.querySelector('.js-result-item-link-copy'),
                itemCategory = lineBreakSanitize(taxonomy),
                itemName = catalog.name,
                itemThumb = catalog.thumb;
                itemPreview = catalog.preview;
                itemDownload = catalog.download_url,
                itemCopy = catalog.copy_url;
                itemThemePreview = catalog.theme_preview;
                itemThemeID = catalog.theme_id;

            // Inject data in card template
            itemCategoryContainer.innerHTML = itemCategory;
            itemNameContainer.innerHTML = itemName;
            itemThumbContainer.src = itemThumb;
            itemPreviewContainer.setAttribute('data-preview', itemPreview);
            itemDownloadBtnContainer.setAttribute('data-href', itemDownload);
            itemDownloadBtnContainer.setAttribute('data-preview', itemThemePreview);
            itemDownloadBtnContainer.setAttribute('data-id', textSanitize(itemName.toLowerCase()));
            itemCopyBtnContainer.setAttribute('data-href', itemCopy);
            itemCopyBtnContainer.setAttribute('data-preview', itemThemePreview);
            itemCopyBtnContainer.setAttribute('data-id', textSanitize(itemName.toLowerCase()));

            // Show anchors href if subscription cookie already exists
            if($.cookie('subscribed_at_' + landing)) {
                itemDownloadBtnContainer.href = itemDownload;
                itemCopyBtnContainer.href = itemCopy;
            }
            
            // Append card in otherResults if category doesnt match with selected category
            if (!moreResults) {
                results.append(clone);
            } else {
                otherResults.append(clone);
            }
        });

        // Animate results view
        form.classList.add('slide-up-out');
        heroContent.classList.add('slide-up-out');

        setTimeout(function(){
            form.classList.add('hide');
            heroContent.classList.add('hide');

            resultsWrapper.classList.add('slide-up-delay');
            resultsWrapper.classList.remove('hide');

            heroContentSuccess.classList.remove('hide');
            heroContentSuccess.classList.add('slide-up');

        }, 100);

        return;
    }
};

// -------------------------------
// Conversion workflow
// -------------------------------
function handleButtonAction() {
    const btnDownloadCatalog = document.querySelectorAll('.js-result-item-link-download'),
          btnCopyCatalog = document.querySelectorAll('.js-result-item-link-copy'),
          btnThumbPreview = document.querySelectorAll('.js-result-item-preview-btn');

    // Get clicked download button
    btnDownloadCatalog.forEach(button => button.addEventListener('click', (event) => {
        handleConversionFlow(event);
    }));

    // Get clicked copy button
    btnCopyCatalog.forEach(button => button.addEventListener('click', (event) => {
        handleConversionFlow(event);
    }));

    btnThumbPreview.forEach(button => button.addEventListener('click', (event) => {
        const thumbPreview = event.target.getAttribute('data-preview');
              modalThumbPreview.src = thumbPreview;

        setTimeout(function(){
            $(modalShowShowPreview).modal('show');
        }, 500);
    }));
}

function handleConversionFlow(event) {
    const btnLink = event.target.getAttribute('data-href');
    
    // Show subscribe modal when copy or download for the first time or time ago
    if(!$.cookie('subscribed_at_' + landing)) {
        event.preventDefault();

        $(modalSubscribe).modal('show');
        amplitude_log_event('tools_' + landing + '_modal', {
            'state': 'opened'
        });

        document.addEventListener('onToolsSubscribe', function() {
            $(modalSubscribe).modal('hide');
            
            amplitude_log_event('tools_' + landing + '_modal', {
                'state': 'closed'
            });

            setTimeout(function(){
                event.target.href = btnLink;
                event.target.download = btnLink;
                event.target.dispatchEvent(new MouseEvent('click'));

                // Update all anchors href
                document.querySelectorAll('[data-href]').forEach(link => {
                    link.href = link.getAttribute('data-href');
                })
                
                buildCustomModal(event);
            }, 500);

            amplitude_log_event('tools_' + landing + '_subscribed');
            $.cookie('subscribed_at_' + landing, true, { expires: 30, path: '/' });
        });
    } else {
        setTimeout(function(){
            event.target.href = btnLink;
            buildCustomModal(event);
        }, 500);
    }
}

function buildCustomModal(event) {
    // Show theme layout related with clicked catalog
    const themePreview = event.target.getAttribute('data-preview'),
          themeID = event.target.getAttribute('data-id');

    modalThemePreview.src = themePreview;
    modalThemeBtn.href = '/crear-mi-tienda-online/' + themeID + '/instalar-diseno';
    $(modalCreateAccount).modal('show');
}

function handleModalSubscribe() {
    $(modalSubscribe).on('show.bs.modal', function () {
        // Close any opened modal before open subscribe modal
        const currentModal = this;

        $(".modal").each(function() {
            if (this !== currentModal) {
                $(this).fadeOut(500, function() {
                    $(this).modal('hide');
                });
            }
        });

        toolsSubscribe('.js-form-subscribe');
    });
}

function checkIfReady() {
    if (typeof Bouncer != 'undefined' && typeof toolsSubscribe != 'undefined' && typeof jQuery !== 'undefined') {
        handleModalSubscribe();
    } else {
        setTimeout(checkIfReady, 1000);
    }
}

checkIfReady();